import React from 'react';
import PropTypes from 'prop-types';

import Money from '../../../common/money';
import * as shapes from '../../shapes';
import OrderInfoItemTitle from '../containers/OrderInfoItemTitle';

const OrderInfoItemSingle = ({ barberId, item, removeItem, setItemQuantity }) => (
  <div
    key={item.id}
    className="o-flexbox o-flexbox--content-align-center u-type--normal c-order-item__product u-mv-"
  >
    <button
      className="c-btn c-btn--blank u-font-color-grey u--ml-"
      type="button"
      onClick={removeItem}
    >
      &times;
    </button>
    <span className="u-flex-1">
      <OrderInfoItemTitle item={item} setItemQuantity={setItemQuantity} barberId={barberId} />
    </span>
    <div className="u-text-right">
      <Money>{item.priceWithoutTaxes * item.quantity}</Money>
    </div>
  </div>
);

OrderInfoItemSingle.propTypes = {
  barberId: PropTypes.string.isRequired,
  item: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    quantity: PropTypes.number,
    priceWithoutTaxes: PropTypes.number,
  }).isRequired,
  removeItem: shapes.handler.isRequired,
  setItemQuantity: shapes.handler.isRequired,
};

export default OrderInfoItemSingle;
